import { render } from "./Cropper.vue?vue&type=template&id=01276dfb&scoped=true"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"

import "./Cropper.vue?vue&type=style&index=0&id=01276dfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01276dfb"]])

export default __exports__